export default {
    namespaced: true,
    state: {
        modal: null,
        modalClass: '',
        loggedIn: !!window.wisenetwork.loggedIn,
        requireLoggedIn: !window.wisenetwork.enableUnregisteredOrdering,
        admin: !!window.wisenetwork.hasPrivileges,
        adminMode: ((hasPrivileges) => {
            let memory = null;
            
            try {
                memory = JSON.parse(localStorage['reservationAdminMode']);
            } catch(e) {
                delete localStorage['reservationAdminMode'];
            }
            
            if (memory !== null && hasPrivileges) {
                return memory;
            }
            
            return hasPrivileges;
        })(window.wisenetwork.hasPrivileges),
        mobile: window.innerWidth <= 768,
    },
    getters: {
        loggedIn: (state) => state.loggedIn,
        requireLoggedIn: (state) => state.requireLoggedIn,
        mobile: (state) => state.mobile,
        admin: (state) => state.admin,
        adminMode: (state) => state.adminMode,
        isEmbed: (state) => {
            const urlParams = new URLSearchParams(window.location.search);
            const isEmbed = urlParams.get('embed');

            return isEmbed == 1;
        }, 
        checkoutUrl(state) {
            const locationParams = new URLSearchParams(window.location.search);
            const urlParams = {
                returnpath: location.pathname
            };
            
            if (state.adminMode) {
                urlParams.forclient = 1;
            }
            
            if (locationParams.get('bareview') == 1) {
                urlParams.bareview = 1;
                urlParams.returnpath += (urlParams.returnpath.indexOf('?') < 0 ? '?' : '&') + 'bareview=1';
            }

            if (locationParams.get('embed') == 1) {
                delete urlParams.returnpath;
            }

            return `${ location.origin }/?action=spacheckout${ Object.keys(urlParams).length > 0 ? '&'+$.param(urlParams) : '' }`;
        },
        modalIsOpen: (state) => state.modal !== null,
        modalName: (state) => state.modal || '',
        modalClass: (state) => state.modalClass,
    },
    mutations: {
        setMobile(state, value) {
            state.mobile = value;
        },
        setModal(state, name) {
            state.modal = name;

            if (name === null) {
                state.modalClass = '';
            }
        },
        setModalClass(state, modalClass) {
            state.modalClass = modalClass;
        },
        toggleAdminMode(state, value) {
            if (typeof value !== 'undefined') {
                state.adminMode = value;
            } else {
                state.adminMode = !state.adminMode;
            }
            
            localStorage['reservationAdminMode'] = JSON.stringify(state.adminMode);
        },
    },
    actions: {
    }
}